import { pathBuilder } from 'config/paths/index';

export const root = '/admin/compliance-hub';
export default pathBuilder(root);
